/**
 * YT Cart Drawer — theme-native replacement for Rebuy Smart Cart.
 */
(function () {
  'use strict';

  var drawer = document.getElementById('yt-cart-drawer');
  if (!drawer) return;

  var configEl = document.querySelector('[data-cart-drawer-config]');
  var config = {};
  if (configEl) {
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      config = {};
    }
  }

  var els = {
    empty: drawer.querySelector('[data-cart-drawer-empty]'),
    items: drawer.querySelector('[data-cart-drawer-items]'),
    footer: drawer.querySelector('[data-cart-drawer-footer]'),
    count: drawer.querySelector('[data-cart-drawer-count]'),
    subtotal: drawer.querySelector('[data-cart-drawer-subtotal]'),
    savings: drawer.querySelector('[data-cart-drawer-savings]'),
    savingsAmount: drawer.querySelector('[data-cart-drawer-savings-amount]'),
    discounts: drawer.querySelector('[data-cart-drawer-discounts]'),
    taxes: drawer.querySelector('[data-cart-drawer-taxes]'),
    upsell: drawer.querySelector('[data-cart-drawer-upsell]'),
    upsellList: drawer.querySelector('[data-cart-drawer-upsell-list]'),
    upsellHeading: drawer.querySelector('[data-cart-drawer-upsell-heading]'),
    popular: drawer.querySelector('[data-cart-drawer-popular]'),
    popularList: drawer.querySelector('[data-cart-drawer-popular-list]'),
    popularHeading: drawer.querySelector('[data-cart-drawer-popular-heading]'),
    note: drawer.querySelector('[data-cart-drawer-note]'),
    form: drawer.querySelector('[data-cart-drawer-form]'),
    discountInput: drawer.querySelector('[data-cart-drawer-discount-input]'),
    discountApply: drawer.querySelector('[data-cart-drawer-discount-apply]'),
    discountError: drawer.querySelector('[data-cart-drawer-discount-error]'),
    discountSuccess: drawer.querySelector('[data-cart-drawer-discount-success]'),
    shipping: drawer.querySelector('[data-cart-drawer-shipping]'),
    shippingMessage: drawer.querySelector('[data-cart-drawer-shipping-message]'),
    shippingFill: drawer.querySelector('[data-cart-drawer-shipping-fill]'),
    gift: drawer.querySelector('[data-cart-drawer-gift]'),
    giftBag: drawer.querySelector('[data-cart-drawer-gift-bag]'),
    giftNote: drawer.querySelector('[data-cart-drawer-gift-note]'),
    giftNoteToggle: drawer.querySelector('[data-cart-drawer-gift-note-toggle]'),
    giftNoteWrap: drawer.querySelector('[data-cart-drawer-gift-note-wrap]'),
    giftHeading: drawer.querySelector('[data-cart-drawer-gift-heading]'),
    giftBagLabel: drawer.querySelector('[data-cart-drawer-gift-bag-label]'),
    discountToggle: drawer.querySelector('[data-cart-drawer-discount-toggle]'),
    discountFields: drawer.querySelector('[data-cart-drawer-discount-fields]'),
    giftBagPrice: drawer.querySelector('[data-cart-drawer-gift-bag-price]'),
    giftBagRow: drawer.querySelector('[data-cart-drawer-gift-bag-row]'),
    giftNoteCount: drawer.querySelector('[data-cart-drawer-gift-note-count]'),
    giftZoom: document.querySelector('[data-gift-bag-zoom-modal]'),
    giftZoomImage: document.querySelector('[data-gift-bag-zoom-image]')
  };

  var state = {
    cart: null,
    isOpen: false,
    lastAddedProductId: null,
    freeShippingQualified: null,
    renderPromise: null,
    openPromise: null,
    cartFetchPromise: null,
    renderToken: 0,
    lineUpdateBusy: false,
    upsellTimer: null,
    lastUpsellKey: '',
    lastItemsSignature: '',
    openedAt: 0,
    giftBagBusy: false,
    giftNoteUserClosed: false
  };

  function isRenderStale(token) {
    return token !== state.renderToken || !state.isOpen;
  }

  function bumpRenderToken() {
    state.renderToken += 1;
    return state.renderToken;
  }

  document.body.classList.add('yt-cart-drawer-enabled');

  function moneyFormat() {
    return document.body.getAttribute('data-money-format') || '${{amount}}';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat());
    }
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function decodeHtmlEntities(str) {
    if (!str) return '';
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  function lineItemTitle(item) {
    return decodeHtmlEntities(item.product_title || item.title || '').trim();
  }

  function lineItemTitleFromRow(row) {
    if (!row) return '';
    var link = row.querySelector('.yt-cart-drawer__item-title a');
    if (link) return (link.textContent || '').trim();
    var title = row.querySelector('.yt-cart-drawer__item-title');
    return title ? (title.textContent || '').trim() : '';
  }

  function sizedImageSrc(src, size) {
    if (!src) return '';
    var unsized = src.replace(/_\d+x(?=\.[a-z0-9]+(\?|$))/i, '');
    if (!size) return unsized;
    return unsized.replace(/(\.[a-z0-9]+)(\?.*)?$/i, '_' + size + '$1$2');
  }

  function lineItemImageSrc(item) {
    var src = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!src) return '';
    if (/_120x\.[a-z0-9]+(\?|$)/i.test(src)) return src;
    return sizedImageSrc(src, '120x');
  }

  function lineItemZoomSrc(item) {
    var src = item.image || (item.featured_image && item.featured_image.url) || giftOptions().image || '';
    return sizedImageSrc(src, '800x');
  }

  function cartItemsSignature(cart) {
    if (!cart || !cart.items) return '';
    return cart.items.map(function (item) {
      return [
        item.key || item.variant_id || item.id,
        item.quantity,
        item.final_line_price,
        lineItemTitle(item),
        lineItemImageSrc(item)
      ].join(':');
    }).join('|');
  }

  function findPreviousCartItem(item) {
    if (!state.cart || !state.cart.items) return null;
    var key = item.key;
    var vid = item.variant_id || item.id;
    for (var i = 0; i < state.cart.items.length; i++) {
      var prev = state.cart.items[i];
      if (key && prev.key === key) return prev;
      if (vid && (prev.variant_id === vid || prev.id === vid)) return prev;
    }
    return null;
  }

  function enrichCartItemFromDom(item, row) {
    var merged = Object.assign({}, item);
    if (!row) return merged;

    if (!lineItemTitle(merged)) {
      var domTitle = lineItemTitleFromRow(row);
      if (domTitle) {
        merged.product_title = domTitle;
        merged.title = domTitle;
      }
    }

    if (!lineItemImageSrc(merged)) {
      var domSrc = (row.querySelector('.yt-cart-drawer__item-image img') || {}).src;
      if (domSrc) {
        merged.image = domSrc.replace(/_120x(\.[a-z0-9]+)(\?.*)?$/i, '$1$2');
      }
    }

    return merged;
  }

  function enrichCartItems(cart) {
    if (!cart || !cart.items) return cart;

    var existingRows = {};
    if (els.items) {
      Array.prototype.forEach.call(els.items.querySelectorAll('[data-cart-drawer-item]'), function (row) {
        var rowKey = row.getAttribute('data-key');
        if (rowKey) existingRows[rowKey] = row;
      });
    }

    var items = cart.items.map(function (item) {
      var merged = Object.assign({}, item);
      var prev = findPreviousCartItem(item);

      if (prev) {
        if (!lineItemTitle(merged) && lineItemTitle(prev)) {
          merged.product_title = prev.product_title || prev.title;
          merged.title = prev.title || prev.product_title;
        }
        if (!lineItemImageSrc(merged) && lineItemImageSrc(prev)) {
          merged.image = prev.image || (prev.featured_image && prev.featured_image.url) || '';
          if (prev.featured_image) merged.featured_image = prev.featured_image;
        }
      }

      var itemKey = item.key || String(item.variant_id || item.id || '');
      return enrichCartItemFromDom(merged, existingRows[itemKey]);
    });

    return Object.assign({}, cart, { items: items });
  }

  function isInternalLineProperty(key) {
    return !key || String(key).charAt(0) === '_' || key === 'Gift note';
  }

  function giftOptions() {
    return config.giftOptions || {};
  }

  function giftBagEnabled() {
    var gift = giftOptions();
    return !!(gift.bagEnabled && gift.variantId);
  }

  // The note needs no bag variant and no eligible line — it applies to the
  // whole cart, so any non-bag item is enough to offer it.
  function giftNoteEnabled() {
    return !!giftOptions().noteEnabled;
  }

  function cartHasNoteableItem(cart) {
    return (cart.items || []).some(function (item) {
      return !isGiftBagItem(item);
    });
  }

  function isGiftBagItem(item) {
    if (!item) return false;
    var gift = giftOptions();
    if (gift.variantId && Number(item.variant_id) === Number(gift.variantId)) return true;
    if (gift.sku && item.sku === gift.sku) return true;
    return item.handle === 'gift-bag';
  }

  function isGiftBagCandidate(product) {
    if (!product) return false;
    var gift = giftOptions();
    if (gift.productId && Number(product.id) === Number(gift.productId)) return true;
    if (gift.variantId && Number(product.variant_id) === Number(gift.variantId)) return true;
    return product.handle === 'gift-bag';
  }

  function isExcludedGiftItem(item) {
    var gift = giftOptions();
    var handle = String(item.handle || '').toLowerCase();
    var excludeHandles = gift.excludeHandles || [];
    var excludeIds = gift.excludeProductIds || [];
    if (excludeHandles.indexOf(handle) !== -1) return true;
    return excludeIds.some(function (id) {
      return Number(id) === Number(item.product_id);
    });
  }

  function isEligibleGiftItem(item) {
    if (!item || isGiftBagItem(item)) return false;
    if (isExcludedGiftItem(item)) return false;
    var gift = giftOptions();
    var handle = String(item.handle || '').toLowerCase();
    if (gift.mode === 'all' || gift.mode === 'all_eligible') {
      return true;
    }
    var handles = gift.testHandles || [];
    return handles.indexOf(handle) !== -1;
  }

  function cartHasEligibleGiftItem(cart) {
    return (cart.items || []).some(isEligibleGiftItem);
  }

  function giftBagItems(cart) {
    return (cart.items || []).filter(isGiftBagItem);
  }

  function giftBagQuantity(cart) {
    return giftBagItems(cart).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function giftNoteFromCart(cart) {
    var attrs = (cart && cart.attributes) || {};
    if (attrs['Gift note']) return attrs['Gift note'];

    var items = cart.items || [];
    var i;
    for (i = 0; i < items.length; i++) {
      if (items[i].properties && items[i].properties['Gift note']) {
        return items[i].properties['Gift note'];
      }
    }
    return '';
  }

  function updateCartBadges(count) {
    document.querySelectorAll('.cart_count').forEach(function (badge) {
      badge.textContent = count;
    });
    if (els.count) {
      els.count.textContent = count;
      els.count.setAttribute('data-count', String(count));
    }
  }

  function cartProductIds(cart) {
    return (cart.items || []).map(function (item) {
      return Number(item.product_id);
    });
  }

  function cartVariantIds(cart) {
    return (cart.items || []).map(function (item) {
      return Number(item.variant_id);
    });
  }

  function sameId(a, b) {
    return Number(a) === Number(b);
  }

  function inIdList(list, id) {
    var target = Number(id);
    return list.some(function (entry) {
      return Number(entry) === target;
    });
  }

  function firstAvailableVariant(variants) {
    if (!variants || !variants.length) return null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0];
  }

  function cartSubtotalCents(cart) {
    if (cart.items_subtotal_price != null) return cart.items_subtotal_price;
    return cart.total_price || 0;
  }

  function cartCurrency(cart) {
    return String((cart.currency || window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.iso_code) || 'GBP').toUpperCase();
  }

  function freeShippingThresholdCents(cart) {
    var thresholds = config.freeShippingThresholds || {};
    var currency = cartCurrency(cart);
    if (thresholds[currency]) return Number(thresholds[currency]);
    if (config.freeShippingThreshold) return Number(config.freeShippingThreshold);
    return 0;
  }

  // Threshold-only shipping bar — no /cart/shipping_rates.json on line edits (slow on mobile).
  function renderFreeShipping(cart, token) {
    if (!els.shipping || !config.freeShippingEnabled) return;

    if (!cart.item_count) {
      if (!isRenderStale(token)) els.shipping.classList.add('is-hidden');
      return;
    }

    var subtotal = cartSubtotalCents(cart);
    var threshold = freeShippingThresholdCents(cart);

    if (!threshold) {
      if (!isRenderStale(token)) els.shipping.classList.add('is-hidden');
      return;
    }

    if (isRenderStale(token)) return;

    els.shipping.classList.remove('is-hidden');

    var isQualified = subtotal >= threshold;
    var progress;
    var message;

    if (isQualified) {
      progress = 100;
      message = config.freeShippingUnlockedLabel || "You've unlocked free standard shipping!";
    } else {
      var remaining = Math.max(0, threshold - subtotal);
      progress = Math.min(100, Math.max(0, (subtotal / threshold) * 100));
      message = (config.freeShippingRemainingLabel || '__AMOUNT__ away from free standard shipping')
        .replace('__AMOUNT__', formatMoney(remaining));
    }

    state.freeShippingQualified = isQualified;

    if (els.shippingMessage) els.shippingMessage.textContent = message;
    if (els.shippingFill) els.shippingFill.style.width = progress + '%';
    els.shipping.setAttribute('data-qualified', isQualified ? 'true' : 'false');
  }

  function fetchCart(options) {
    options = options || {};
    // Coalesce concurrent /cart.js reads (open + cart:refresh race).
    if (!options.force && state.cartFetchPromise) return state.cartFetchPromise;

    state.cartFetchPromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .finally(function () {
        state.cartFetchPromise = null;
      });

    return state.cartFetchPromise;
  }

  function hasRenderedItems() {
    return !!(els.items && els.items.querySelector('[data-cart-drawer-item]'));
  }

  function cartItemsDomIncomplete(cart) {
    if (!els.items || !cart || !cart.items.length) return false;

    var rows = els.items.querySelectorAll('[data-cart-drawer-item]');
    if (rows.length !== cart.items.length) return true;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var row = rows[i];
      if (!row) return true;

      var expectedTitle = lineItemTitle(item);
      var renderedTitle = lineItemTitleFromRow(row);
      var hasImg = !!row.querySelector('.yt-cart-drawer__item-image img');
      var expectedImage = lineItemImageSrc(item);

      if (expectedTitle && !renderedTitle) return true;
      if (expectedImage && !hasImg) return true;
    }

    return false;
  }

  function shouldPreserveItemsDom(cart) {
    return hasRenderedItems() && !cartItemsDomIncomplete(cart);
  }

  function hasRenderedUpsells() {
    if (els.upsellList && els.upsellList.querySelector('[data-upsell-card]')) return true;
    return !!(els.popularList && els.popularList.querySelector('[data-upsell-card]'));
  }

  function updateCartDiscounts(discountValue) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: discountValue })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function applyDiscountCode(code) {
    return updateCartDiscounts(code.trim()).then(function () {
      return fetchCart();
    });
  }

  function getAppliedDiscountCodes(cart) {
    if (!cart || !cart.discount_codes || !cart.discount_codes.length) return [];

    return cart.discount_codes
      .map(function (entry) {
        return entry.code;
      })
      .filter(Boolean);
  }

  function removeDiscountCode(codeToRemove) {
    var normalized = codeToRemove.trim().toLowerCase();
    var remaining = getAppliedDiscountCodes(state.cart).filter(function (code) {
      return code.toLowerCase() !== normalized;
    });

    return updateCartDiscounts(remaining.length ? remaining.join(',') : '').then(function () {
      return fetchCart();
    });
  }

  function cartItemsTotalCents(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + Number(item.final_line_price || 0);
    }, 0);
  }

  function cartLevelProductDiscountCents(cart) {
    return (cart.cart_level_discount_applications || []).reduce(function (sum, discount) {
      if (discount.target_type === 'shipping_line') return sum;
      return sum + Number(discount.total_allocated_amount || 0);
    }, 0);
  }

  function cartMerchandiseSubtotalCents(cart) {
    var itemsTotal = cartItemsTotalCents(cart);
    var productDiscounts = cartLevelProductDiscountCents(cart);
    var afterDiscounts = Math.max(0, itemsTotal - productDiscounts);

    // Prefer Shopify's total when it matches merchandise math.
    // If total_price is higher than visible items (e.g. shipping leaked in), never use it.
    var apiTotal = Number(cart.total_price || 0);
    if (apiTotal > itemsTotal) return afterDiscounts;
    if (apiTotal >= 0 && apiTotal <= itemsTotal) return apiTotal;
    return afterDiscounts;
  }

  function discountAmountForCode(cart, code) {
    var normalized = code.trim().toLowerCase();
    var applications = cart.cart_level_discount_applications || [];
    var i;
    var discount;
    var amount = 0;
    var matched = false;

    for (i = 0; i < applications.length; i++) {
      discount = applications[i];
      if (!discount.title || discount.title.toLowerCase() !== normalized) continue;
      matched = true;
      if (discount.target_type === 'shipping_line') continue;
      amount += Number(discount.total_allocated_amount || 0);
    }

    if (matched) return amount;
    return null;
  }

  function shippingDiscountLabel(cart) {
    var applications = cart.cart_level_discount_applications || [];
    var i;
    for (i = 0; i < applications.length; i++) {
      if (applications[i].target_type === 'shipping_line') {
        return applications[i].title || 'Free shipping';
      }
    }
    return null;
  }

  function discountIsApplied(cart, code) {
    var normalized = code.trim().toLowerCase();
    if (!normalized) return false;

    if (cart.discount_codes && cart.discount_codes.length) {
      return cart.discount_codes.some(function (entry) {
        return entry.code && entry.code.toLowerCase() === normalized && entry.applicable !== false;
      });
    }

    return (cart.cart_level_discount_applications || []).some(function (discount) {
      return discount.title && discount.title.toLowerCase() === normalized;
    });
  }

  function showDiscountMessage(type, message) {
    if (els.discountError) {
      els.discountError.textContent = type === 'error' ? message : '';
      els.discountError.classList.toggle('is-hidden', type !== 'error');
    }
    if (els.discountSuccess) {
      els.discountSuccess.textContent = type === 'success' ? message : '';
      els.discountSuccess.classList.toggle('is-hidden', type !== 'success');
    }
  }

  function clearDiscountMessages() {
    showDiscountMessage('', '');
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (res) {
      if (!res.ok) throw res;
      return res.json();
    });
  }

  function changeLineByKey(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) {
      if (!res.ok) throw res;
      return res.json();
    });
  }

  function addVariant(variantId, quantity) {
    if (window.YTAddToCart && typeof window.YTAddToCart.add === 'function') {
      return window.YTAddToCart.add({ id: variantId, quantity: quantity || 1 });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (res) {
      if (!res.ok) throw res;
      return res.json().then(function (data) {
        if (window.YTAnalytics && typeof window.YTAnalytics.trackAddToCart === 'function') {
          window.YTAnalytics.trackAddToCart(data);
        }
        return data;
      });
    });
  }

  function variantLabel(item) {
    if (!item.variant_title || item.variant_title === 'Default Title') return '';
    return item.variant_title;
  }

  function lineItemHtml(item, line) {
    var title = lineItemTitle(item);
    var imageSrc = lineItemImageSrc(item);
    var isBag = isGiftBagItem(item);
    if (!imageSrc && isBag) imageSrc = sizedImageSrc(giftOptions().image, '120x');
    var img = '';
    if (imageSrc && isBag) {
      img = ''
        + '<button type="button" class="yt-cart-drawer__item-image yt-cart-drawer__item-image--zoom" data-gift-bag-zoom data-zoom-src="' + escapeHtml(lineItemZoomSrc(item) || imageSrc) + '" aria-label="View larger gift bag image">'
        + '<img src="' + escapeHtml(imageSrc) + '" alt="' + escapeHtml(title) + '" width="90" height="90" loading="lazy">'
        + '<span class="yt-cart-drawer__zoom-veil" aria-hidden="true">'
        + '<span class="yt-cart-drawer__zoom-icon"></span>'
        + '</span>'
        + '</button>';
    } else if (imageSrc) {
      img = '<a class="yt-cart-drawer__item-image" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(imageSrc) + '" alt="' + escapeHtml(title) + '" width="90" height="90" loading="lazy"></a>';
    }
    var variant = variantLabel(item);
    var variantHtml = variant ? '<p class="yt-cart-drawer__item-variant">' + escapeHtml(variant) + '</p>' : '';
    var priceHtml = item.final_price < item.original_price
      ? '<span>' + formatMoney(item.final_line_price) + '</span> <span class="was_price">' + formatMoney(item.original_line_price) + '</span>'
      : '<span>' + formatMoney(item.final_line_price) + '</span>';

    if (item.final_price === 0) {
      priceHtml = '<span>' + escapeHtml(config.freePriceText || 'Free') + '</span>';
    }

    var propsHtml = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        var val = item.properties[key];
        if (val && !isInternalLineProperty(key)) {
          propsHtml += '<p class="yt-cart-drawer__item-property">' + escapeHtml(key) + ': ' + escapeHtml(String(val)) + '</p>';
        }
      });
    }

    var itemKey = item.key || String(item.variant_id || item.id || '');
    var qtyHtml = ''
        + '<div class="yt-cart-drawer__qty" data-cart-drawer-qty>'
        + '<button type="button" class="yt-cart-drawer__qty-btn" data-qty-change="-1" aria-label="Decrease quantity">−</button>'
        + '<input class="yt-cart-drawer__qty-input" type="text" inputmode="numeric" pattern="[0-9]*" value="' + item.quantity + '" aria-label="Quantity">'
        + '<button type="button" class="yt-cart-drawer__qty-btn" data-qty-change="1" aria-label="Increase quantity">+</button>'
        + '</div>';

    return ''
      + '<li class="yt-cart-drawer__item' + (isBag ? ' yt-cart-drawer__item--gift-bag' : '') + '" data-cart-drawer-item data-line="' + line + '" data-key="' + escapeHtml(itemKey) + '"' + (isBag ? ' data-gift-bag-line' : '') + '>'
      + img
      + '<div class="yt-cart-drawer__item-details">'
      + '<div class="yt-cart-drawer__item-heading">'
      + '<p class="yt-cart-drawer__item-title">' + (isBag ? escapeHtml(title) : '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(title) + '</a>') + '</p>'
      + '<button type="button" class="yt-cart-drawer__remove" data-cart-drawer-remove aria-label="Remove item">&times;</button>'
      + '</div>'
      + variantHtml
      + propsHtml
      + '<p class="yt-cart-drawer__item-price">' + priceHtml + '</p>'
      + qtyHtml
      + '</div>'
      + '</li>';
  }

  function renderItems(cart) {
    if (!els.items) return;

    if (!cart.items.length) {
      els.items.innerHTML = '';
      els.items.classList.add('is-hidden');
      if (els.empty) els.empty.classList.remove('is-hidden');
      if (els.footer) els.footer.classList.add('is-hidden');
      state.lastItemsSignature = '';
      return;
    }

    if (els.empty) els.empty.classList.add('is-hidden');
    els.items.classList.remove('is-hidden');
    if (els.footer) els.footer.classList.remove('is-hidden');

    els.items.innerHTML = cart.items.map(function (item, index) {
      return lineItemHtml(item, index + 1);
    }).join('');

    state.lastItemsSignature = cartItemsSignature(cart);
  }

  function renderSummary(cart) {
    if (els.subtotal) {
      els.subtotal.innerHTML = formatMoney(cartMerchandiseSubtotalCents(cart));
    }

    if (els.discounts) {
      var discountHtml = '';
      var shownTitles = {};
      var discountCodes = cart.discount_codes || [];
      var shippingLabel = shippingDiscountLabel(cart);

      discountCodes.forEach(function (entry) {
        if (!entry.code) return;

        var code = entry.code;
        var amount = discountAmountForCode(cart, code);
        var amountHtml = '';
        var removeLabel = (config.discountRemoveLabel || 'Remove discount code __CODE__').replace('__CODE__', code);

        if (amount != null && amount > 0) {
          amountHtml = ' −' + formatMoney(amount);
        } else if (shippingLabel) {
          amountHtml = ' − Free shipping';
        }

        discountHtml += ''
          + '<div class="yt-cart-drawer__discount-row">'
          + '<span class="yt-cart-drawer__discount-name">' + escapeHtml(code) + amountHtml + '</span>'
          + '<button type="button" class="yt-cart-drawer__discount-remove" data-cart-drawer-discount-remove data-discount-code="' + escapeHtml(code) + '" aria-label="' + escapeHtml(removeLabel) + '"><span aria-hidden="true">&times;</span></button>'
          + '</div>';

        shownTitles[code.toLowerCase()] = true;
      });

      (cart.cart_level_discount_applications || []).forEach(function (discount) {
        if (!discount.title || shownTitles[discount.title.toLowerCase()]) return;
        if (discount.target_type === 'shipping_line') {
          discountHtml += ''
            + '<div class="yt-cart-drawer__discount-row yt-cart-drawer__discount-row--automatic">'
            + '<span class="yt-cart-drawer__discount-name">' + escapeHtml(discount.title) + ' − Free shipping</span>'
            + '</div>';
          return;
        }

        discountHtml += ''
          + '<div class="yt-cart-drawer__discount-row yt-cart-drawer__discount-row--automatic">'
          + '<span class="yt-cart-drawer__discount-name">' + escapeHtml(discount.title) + ' −' + formatMoney(discount.total_allocated_amount) + '</span>'
          + '</div>';
      });

      els.discounts.innerHTML = discountHtml;
      els.discounts.classList.toggle('is-hidden', !discountHtml);
    }

    if (els.savings && els.savingsAmount && config.displaySavings) {
      var savings = cartLevelProductDiscountCents(cart);
      if (savings > 0) {
        els.savings.classList.remove('is-hidden');
        els.savingsAmount.textContent = formatMoney(savings);
      } else {
        els.savings.classList.add('is-hidden');
      }
    }

    if (els.taxes && config.taxesShippingHtml) {
      els.taxes.innerHTML = config.taxesShippingHtml;
      if (config.hasShippingPolicy) {
        els.taxes.querySelectorAll('a[href="#yt-cart-shipping-policy"]').forEach(function (link) {
          link.setAttribute('data-cart-drawer-shipping-policy', '');
          link.setAttribute('role', 'button');
        });
      }
    }

    if (els.note && typeof cart.note === 'string') {
      els.note.value = cart.note;
    }

    renderGiftPanel(cart);
  }

  function renderGiftPanel(cart) {
    if (!els.gift) return;

    var gift = giftOptions();
    var showBag = giftBagEnabled() && cartHasEligibleGiftItem(cart);
    var showNote = giftNoteEnabled() && cartHasNoteableItem(cart);
    var show = showBag || showNote;
    els.gift.classList.toggle('is-hidden', !show);
    if (els.giftBagRow) els.giftBagRow.classList.toggle('is-hidden', !showBag);
    if (els.giftNoteToggle) els.giftNoteToggle.classList.toggle('is-hidden', !showNote);
    if (!showNote) setGiftNoteOpen(false, false);

    if (!show) return;

    if (els.giftHeading && gift.heading) els.giftHeading.textContent = gift.heading;
    if (els.giftBagLabel && gift.bagLabel) els.giftBagLabel.textContent = gift.bagLabel;
    if (els.giftNote && gift.notePlaceholder) els.giftNote.placeholder = gift.notePlaceholder;
    if (els.giftBagPrice && gift.price != null) {
      els.giftBagPrice.textContent = formatMoney(gift.price);
    }

    if (els.giftBag) {
      els.giftBag.checked = giftBagQuantity(cart) > 0;
    }

    var hasNote = !!giftNoteFromCart(cart);
    if (els.giftNote && document.activeElement !== els.giftNote) {
      els.giftNote.value = giftNoteFromCart(cart);
      updateGiftNoteCount();
    }
    if (showNote && hasNote && !state.giftNoteUserClosed) {
      setGiftNoteOpen(true, false);
    }
  }

  function updateGiftNoteCount() {
    if (!els.giftNoteCount || !els.giftNote) return;

    var max = els.giftNote.getAttribute('maxlength');
    if (!max) return;

    els.giftNoteCount.textContent = els.giftNote.value.length + ' / ' + max;
  }

  function setGiftNoteOpen(isOpen, focusNote) {
    if (els.giftNoteWrap) {
      els.giftNoteWrap.classList.toggle('is-hidden', !isOpen);
    }
    if (els.giftNoteToggle) {
      els.giftNoteToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      els.giftNoteToggle.textContent = 'Add a gift note (free)';
    }
    if (isOpen) updateGiftNoteCount();
    if (isOpen && focusNote && els.giftNote) {
      els.giftNote.focus();
    }
  }

  function setDiscountOpen(isOpen, focusInput) {
    if (els.discountFields) {
      els.discountFields.classList.toggle('is-hidden', !isOpen);
    }
    if (els.discountToggle) {
      els.discountToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
    if (isOpen && focusInput && els.discountInput) {
      els.discountInput.focus();
    }
  }

  function updateLineQuantities(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw res;
      return res.json();
    });
  }

  function addGiftBag(quantity) {
    var variantId = Number(giftOptions().variantId);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return fetchCart({ force: true });
      });
    });
  }

  function applyGiftBagQuantity(cart, quantity) {
    var bags = giftBagItems(cart);
    var qty = Math.max(0, Number(quantity) || 0);

    if (qty < 1) {
      if (!bags.length) return Promise.resolve(cart);
      var clear = {};
      bags.forEach(function (bag) {
        if (bag.key) clear[bag.key] = 0;
      });
      return Object.keys(clear).length ? updateLineQuantities(clear) : Promise.resolve(cart);
    }

    if (!bags.length) return addGiftBag(qty);

    var updates = {};
    updates[bags[0].key] = qty;
    bags.slice(1).forEach(function (bag) {
      if (bag.key) updates[bag.key] = 0;
    });
    return updateLineQuantities(updates);
  }

  function setGiftBagQuantity(quantity) {
    return fetchCart({ force: true }).then(function (cart) {
      return applyGiftBagQuantity(cart, quantity);
    });
  }

  function syncGiftBagState(cart) {
    if (!giftOptions().variantId || !cart || !cart.items) return Promise.resolve(cart);

    var bags = giftBagItems(cart);
    if (!bags.length) return Promise.resolve(cart);

    if (!giftBagEnabled() || !cartHasEligibleGiftItem(cart)) {
      return applyGiftBagQuantity(cart, 0);
    }

    if (bags.length > 1) {
      return applyGiftBagQuantity(cart, giftBagQuantity(cart));
    }

    return Promise.resolve(cart);
  }

  function normalizeUpsellProduct(p) {
    return {
      id: Number(p.id),
      handle: p.handle,
      title: p.title,
      url: p.url,
      featured_image: p.featured_image,
      variant_id: Number(p.variant_id),
      price: p.price
    };
  }

  function setPopularVisibility(isEmpty) {
    if (!els.popular) return;
    if (isEmpty) {
      els.popular.classList.remove('is-hidden');
      els.popular.removeAttribute('hidden');
    } else {
      els.popular.classList.add('is-hidden');
      els.popular.setAttribute('hidden', 'hidden');
      if (els.popularList) {
        els.popularList.classList.remove('yt-cart-drawer__upsell-list--carousel');
        els.popularList.innerHTML = '';
      }
    }
  }

  function renderProductCarousel(sectionEl, listEl, headingEl, products, opts, token) {
    if (isRenderStale(token)) return;

    opts = opts || {};
    if (!products.length) {
      if (sectionEl) sectionEl.classList.add('is-hidden');
      if (listEl) {
        listEl.classList.remove('yt-cart-drawer__upsell-list--carousel');
        listEl.innerHTML = '';
      }
      return;
    }

    if (sectionEl) {
      sectionEl.classList.remove('is-hidden');
      sectionEl.removeAttribute('hidden');
    }
    if (headingEl && opts.heading) headingEl.textContent = opts.heading;
    if (listEl) {
      listEl.classList.add('yt-cart-drawer__upsell-list--carousel');
      listEl.setAttribute('aria-label', opts.ariaLabel || opts.heading || 'Suggested products');
      listEl.innerHTML = products.map(upsellCardHtml).join('');
    }
  }

  function renderUpsellProducts(products, token) {
    renderProductCarousel(
      els.upsell,
      els.upsellList,
      els.upsellHeading,
      products,
      {
        heading: config.upsellHeading || 'Complete your order',
        ariaLabel: config.upsellHeading || 'Suggested products'
      },
      token
    );
  }

  function renderPopularProducts(products, token) {
    renderProductCarousel(
      els.popular,
      els.popularList,
      els.popularHeading,
      products,
      {
        heading: config.emptyCartHeading || 'Popular right now',
        ariaLabel: config.emptyCartHeading || 'Popular right now'
      },
      token
    );
  }

  function upsellCardHtml(product) {
    var price = formatMoney(product.price);
    return ''
      + '<article class="yt-cart-drawer__upsell-card" data-upsell-card data-variant-id="' + product.variant_id + '">'
      + '<a class="yt-cart-drawer__upsell-image" href="' + product.url + '" tabindex="-1">'
      + (product.featured_image ? '<img src="' + product.featured_image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="120" height="120">' : '')
      + '</a>'
      + '<div class="yt-cart-drawer__upsell-body">'
      + '<p class="yt-cart-drawer__upsell-title"><a href="' + product.url + '">' + escapeHtml(product.title) + '</a></p>'
      + '<p class="yt-cart-drawer__upsell-price">' + price + '</p>'
      + '</div>'
      + '<button type="button" class="yt-cart-drawer__upsell-add" data-upsell-add>Add</button>'
      + '</article>';
  }

  function mapRecommendationProducts(products) {
    return (products || []).map(function (p) {
      var variant = firstAvailableVariant(p.variants);
      return {
        id: Number(p.id),
        handle: p.handle,
        title: p.title,
        url: '/products/' + p.handle,
        featured_image: p.featured_image ? p.featured_image.replace(/(\.[^.]+)$/, '_240x$1') : '',
        variant_id: variant ? Number(variant.id) : null,
        price: variant ? variant.price : 0
      };
    }).filter(function (p) {
      return p.variant_id;
    });
  }

  function fetchRecommendationsWithIntent(productId, limit, intent) {
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=' + intent;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations failed');
        return res.json();
      })
      .then(function (data) {
        return mapRecommendationProducts(data.products);
      })
      .catch(function () {
        return [];
      });
  }

  function shuffleArray(items) {
    var list = items.slice();
    for (var i = list.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function crossSellCandidates() {
    return shuffleArray(config.crossSellProducts || []);
  }

  function fetchRecommendations(productId, limit) {
    return fetchRecommendationsWithIntent(productId, limit, 'complementary').then(function (products) {
      if (products.length >= limit) return products.slice(0, limit);

      var remaining = limit - products.length;
      if (remaining <= 0) return products;

      return fetchRecommendationsWithIntent(productId, remaining + products.length, 'related').then(function (related) {
        related.forEach(function (product) {
          if (products.length >= limit) return;
          var exists = products.some(function (existing) {
            return sameId(existing.id, product.id);
          });
          if (!exists) products.push(product);
        });
        return products.slice(0, limit);
      });
    });
  }

  function upsellEligible(products, candidate, inCartProducts, inCartVariants, isEmpty, limit) {
    if (products.length >= limit) return false;
    if (!candidate || !candidate.variant_id) return false;
    if (isGiftBagCandidate(candidate)) return false;
    if (!isEmpty && (inIdList(inCartProducts, candidate.id) || inIdList(inCartVariants, candidate.variant_id))) {
      return false;
    }
    return !products.some(function (existing) {
      return sameId(existing.id, candidate.id);
    });
  }

  function pushUpsell(products, candidate, inCartProducts, inCartVariants, isEmpty, limit) {
    if (!upsellEligible(products, candidate, inCartProducts, inCartVariants, isEmpty, limit)) return false;
    products.push(normalizeUpsellProduct(candidate));
    return true;
  }

  function fetchUpsellRecommendationMix(anchorProductId, relatedLimit, complementaryLimit) {
    var relatedPromise = relatedLimit > 0
      ? fetchRecommendationsWithIntent(anchorProductId, relatedLimit + 2, 'related')
      : Promise.resolve([]);
    var complementaryPromise = complementaryLimit > 0
      ? fetchRecommendationsWithIntent(anchorProductId, complementaryLimit + 2, 'complementary')
      : Promise.resolve([]);

    return Promise.all([relatedPromise, complementaryPromise]).then(function (results) {
      return {
        related: results[0] || [],
        complementary: results[1] || []
      };
    });
  }

  function upsellLoadingHtml() {
    return ''
      + '<div class="yt-cart-drawer__upsell-skeleton" aria-hidden="true"></div>'
      + '<div class="yt-cart-drawer__upsell-skeleton" aria-hidden="true"></div>'
      + '<div class="yt-cart-drawer__upsell-skeleton" aria-hidden="true"></div>';
  }

  function upsellKey(cart) {
    var isEmpty = !cart.items.length;
    var anchor = '';
    if (!isEmpty && cart.items.length) {
      var item = cart.items[cart.items.length - 1];
      if (state.lastAddedProductId) {
        item = cart.items.find(function (entry) {
          return sameId(entry.product_id, state.lastAddedProductId);
        }) || item;
      }
      anchor = String(item.product_id || '');
    }
    return (isEmpty ? 'empty' : 'filled') + ':' + anchor + ':' + cartProductIds(cart).sort().join(',');
  }

  function renderUpsells(cart, token, options) {
    options = options || {};
    if (!config.upsellEnabled || !els.upsellList || isRenderStale(token)) {
      return Promise.resolve();
    }

    var key = upsellKey(cart);
    // Line edits: keep current upsell DOM unless cart emptied / product set changed enough to need refresh.
    if (options.skipUpsellFetch && state.lastUpsellKey && key === state.lastUpsellKey && cart.items.length) {
      setPopularVisibility(false);
      return Promise.resolve();
    }

    var isEmpty = !cart.items.length;
    setPopularVisibility(isEmpty);

    if (isEmpty) {
      return renderEmptyCartUpsells(cart, token, options, key);
    }

    return renderFilledCartUpsells(cart, token, options, key);
  }

  function renderEmptyCartUpsells(cart, token, options, key) {
    var limit = config.upsellLimit || 4;
    var inCartProducts = cartProductIds(cart);
    var inCartVariants = cartVariantIds(cart);
    var isEmpty = true;
    var popularProducts = [];
    var upsellProducts = [];

    (config.emptyCartProducts || []).forEach(function (p) {
      if (popularProducts.length >= limit) return;
      pushUpsell(popularProducts, p, inCartProducts, inCartVariants, isEmpty, limit);
    });

    (config.upsellProducts || []).forEach(function (p) {
      if (upsellProducts.length >= limit) return;
      pushUpsell(upsellProducts, p, inCartProducts, inCartVariants, isEmpty, limit);
    });

    var popularRemaining = limit - popularProducts.length;
    var upsellRemaining = limit - upsellProducts.length;
    var crossSellLimit = upsellRemaining;
    var anchorProductId = config.emptyCartAnchorProductId;

    if (!options.skipUpsellFetch) {
      if (els.popularList && popularRemaining > 0) {
        els.popularList.classList.add('yt-cart-drawer__upsell-list--carousel');
        els.popularList.innerHTML = upsellLoadingHtml();
      }
      if (els.upsellList && (upsellRemaining > 0 || (config.crossSellProducts || []).length)) {
        els.upsellList.classList.add('yt-cart-drawer__upsell-list--carousel');
        els.upsellList.innerHTML = upsellLoadingHtml();
      }
    } else if (popularProducts.length || upsellProducts.length) {
      state.lastUpsellKey = key;
      renderPopularProducts(popularProducts.slice(0, limit), token);
      renderUpsellProducts(upsellProducts.slice(0, limit), token);
      return Promise.resolve();
    }

    var popularPromise = Promise.resolve();
    if (popularRemaining > 0 && config.upsellUseRecommendations && anchorProductId && !options.skipUpsellFetch) {
      popularPromise = fetchRecommendations(anchorProductId, popularRemaining + popularProducts.length).then(function (recommended) {
        recommended.forEach(function (product) {
          pushUpsell(popularProducts, product, inCartProducts, inCartVariants, isEmpty, limit);
        });
      });
    }

    return popularPromise.then(function () {
      var excludeIds = popularProducts.map(function (p) {
        return p.id;
      });
      var crossAdded = 0;

      crossSellCandidates().forEach(function (product) {
        if (crossAdded >= crossSellLimit) return;
        if (excludeIds.some(function (id) {
          return sameId(id, product.id);
        })) return;
        if (pushUpsell(upsellProducts, product, inCartProducts, inCartVariants, isEmpty, limit)) {
          crossAdded += 1;
        }
      });

      if (upsellProducts.length < limit && config.upsellUseRecommendations && anchorProductId && !options.skipUpsellFetch) {
        return fetchRecommendationsWithIntent(anchorProductId, limit - upsellProducts.length + 2, 'complementary').then(function (complementary) {
          complementary.forEach(function (product) {
            if (excludeIds.some(function (id) {
              return sameId(id, product.id);
            })) return;
            pushUpsell(upsellProducts, product, inCartProducts, inCartVariants, isEmpty, limit);
          });
        });
      }
    }).then(function () {
      if (isRenderStale(token)) return;

      state.lastUpsellKey = key;
      renderPopularProducts(popularProducts.slice(0, limit), token);
      renderUpsellProducts(upsellProducts.slice(0, limit), token);
    });
  }

  function renderFilledCartUpsells(cart, token, options, key) {
    var inCartProducts = cartProductIds(cart);
    var inCartVariants = cartVariantIds(cart);
    var limit = config.upsellLimit || 4;
    var isEmpty = false;
    var products = [];

    (config.upsellProducts || []).forEach(function (p) {
      if (products.length >= limit) return;
      if (!inIdList(inCartProducts, p.id) && !inIdList(inCartVariants, p.variant_id)) {
        products.push(normalizeUpsellProduct(p));
      }
    });

    var remaining = limit - products.length;
    var recommendationPromise = Promise.resolve();
    var anchorProductId = null;
    var relatedLimit = 0;
    var crossSellLimit = 0;

    if (remaining > 0 && config.upsellUseRecommendations && !options.skipUpsellFetch && cart.items.length) {
      var anchor = cart.items[cart.items.length - 1];
      if (state.lastAddedProductId) {
        anchor = cart.items.find(function (item) {
          return sameId(item.product_id, state.lastAddedProductId);
        }) || anchor;
      }
      anchorProductId = anchor.product_id;
      relatedLimit = Math.min(config.upsellRelatedLimit != null ? config.upsellRelatedLimit : 2, remaining);
      crossSellLimit = Math.max(0, remaining - relatedLimit);
    }

    if (remaining > 0 && anchorProductId) {
      if (!isRenderStale(token) && els.upsell) els.upsell.classList.remove('is-hidden');
      if (!isRenderStale(token) && els.upsellList && !options.skipUpsellFetch) {
        els.upsellList.classList.add('yt-cart-drawer__upsell-list--carousel');
        els.upsellList.innerHTML = upsellLoadingHtml();
      }

      recommendationPromise = fetchUpsellRecommendationMix(
        anchorProductId,
        relatedLimit,
        Math.max(0, limit - relatedLimit)
      ).then(function (mix) {
        var relatedAdded = 0;

        mix.related.forEach(function (product) {
          if (relatedAdded >= relatedLimit) return;
          if (pushUpsell(products, product, inCartProducts, inCartVariants, isEmpty, limit)) {
            relatedAdded += 1;
          }
        });

        var crossAdded = 0;
        crossSellCandidates().forEach(function (product) {
          if (crossAdded >= crossSellLimit) return;
          if (pushUpsell(products, product, inCartProducts, inCartVariants, isEmpty, limit)) {
            crossAdded += 1;
          }
        });

        if (products.length < limit) {
          mix.complementary.forEach(function (product) {
            pushUpsell(products, product, inCartProducts, inCartVariants, isEmpty, limit);
          });
        }
      });
    } else if (options.skipUpsellFetch && remaining > 0 && products.length) {
      state.lastUpsellKey = key;
      renderUpsellProducts(products.slice(0, limit), token);
      return Promise.resolve();
    }

    return recommendationPromise.then(function () {
      if (isRenderStale(token)) return;

      state.lastUpsellKey = key;
      renderUpsellProducts(products.slice(0, limit), token);
    });
  }

  function render(cart, options) {
    options = options || {};
    var token = state.renderToken;
    var enrichedCart = enrichCartItems(cart);
    state.cart = enrichedCart;
    updateCartBadges(enrichedCart.item_count);

    if (!state.isOpen) {
      return Promise.resolve();
    }

    // summaryOnly: used after optimistic remove — avoid wiping/rebuilding item list DOM.
    if (!options.summaryOnly) {
      var signature = cartItemsSignature(enrichedCart);
      var skipItemsRender = options.light
        && signature === state.lastItemsSignature
        && !cartItemsDomIncomplete(enrichedCart);

      if (!skipItemsRender) {
        renderItems(enrichedCart);
      }
    }
    renderSummary(enrichedCart);
    renderFreeShipping(enrichedCart, token);

    if (options.light || options.summaryOnly) {
      // Line edits: keep existing upsells, do not refetch recommendations.
      return Promise.resolve();
    }

    // Full open/refresh: show configured upsells + recommendations.
    return renderUpsells(enrichedCart, token, options);
  }

  function renderCart(cart, options) {
    try {
      return Promise.resolve(render(cart, options));
    } catch (err) {
      console.error('[YTCartDrawer] render failed', err);
      return Promise.resolve();
    }
  }

  function applyCartUpdate(promise, options) {
    options = options || {};
    var tokenAtStart = state.renderToken;
    return promise
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) {
          return fetchCart({ force: true });
        }
        return cart;
      })
      .then(function (cart) {
        return syncGiftBagState(cart);
      })
      .then(function (cart) {
        // Closed mid-request: update badge only, never rebuild drawer DOM/upsells.
        if (!state.isOpen || tokenAtStart !== state.renderToken) {
          state.cart = cart;
          updateCartBadges(cart.item_count);
          return cart;
        }
        return renderCart(cart, options);
      })
      .catch(function (err) {
        console.error('[YTCartDrawer] cart update failed', err);
        if (!state.isOpen) {
          return refreshBadgeOnly();
        }
        return fetchCart()
          .then(function (cart) {
            return renderCart(cart, { light: true });
          })
          .catch(function () {});
      });
  }

  function runLineUpdate(promise, options) {
    if (state.lineUpdateBusy) {
      return Promise.resolve();
    }
    state.lineUpdateBusy = true;
    drawer.classList.add('is-updating');

    var safetyTimer = setTimeout(function () {
      state.lineUpdateBusy = false;
      drawer.classList.remove('is-updating');
    }, 5000);

    return applyCartUpdate(promise, options || { light: true }).finally(function () {
      clearTimeout(safetyTimer);
      state.lineUpdateBusy = false;
      drawer.classList.remove('is-updating');
    });
  }

  function open() {
    state.isOpen = true;
    state.openedAt = Date.now();
    var token = bumpRenderToken();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('yt-cart-drawer-open');
    drawer.classList.remove('is-updating');
    state.lineUpdateBusy = false;

    // Instant paint from cache so close→reopen never waits on network.
    if (state.cart) {
      renderCart(state.cart, {
        light: true,
        summaryOnly: shouldPreserveItemsDom(state.cart)
      });
    }

    var previousUpsellKey = state.lastUpsellKey;
    var hadUpsells = hasRenderedUpsells();

    var promise = fetchCart({ force: true })
      .then(function (cart) {
        if (!state.isOpen || token !== state.renderToken) {
          state.cart = cart;
          updateCartBadges(cart.item_count);
          return cart;
        }

        var nextKey = upsellKey(cart);
        var cartUnchanged = !!(previousUpsellKey && previousUpsellKey === nextKey);
        var keepItemsDom = cartUnchanged && shouldPreserveItemsDom(cart);

        return renderCart(cart, {
          light: true,
          summaryOnly: keepItemsDom
        }).then(function () {
          if (!state.isOpen || token !== state.renderToken) return cart;

          // Same cart as last open: keep upsell DOM, skip recommendation refetch.
          if (cartUnchanged && hadUpsells && hasRenderedUpsells()) {
            setPopularVisibility(!cart.items.length);
            state.lastUpsellKey = nextKey;
            return cart;
          }

          // Full upsell render inline — this store has no manual upsell
          // products, so a deferred/skip-fetch pass leaves the section empty.
          return renderUpsells(cart, token, {}).then(function () {
            return cart;
          });
        });
      })
      .catch(function () {})
      .finally(function () {
        if (state.openPromise === promise) {
          state.openPromise = null;
        }
      });

    state.openPromise = promise;
    return promise;
  }

  function close() {
    state.isOpen = false;
    bumpRenderToken();
    state.lineUpdateBusy = false;
    state.openPromise = null;
    state.renderPromise = null;
    clearTimeout(state.upsellTimer);
    state.upsellTimer = null;
    // Keep item/upsell DOM on close so reopen is instant; just stop pending work.
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-updating');
    document.body.classList.remove('yt-cart-drawer-open');
    closeShippingPolicy();
    closeGiftBagZoom();
  }

  function refreshBadgeOnly() {
    return fetchCart()
      .then(function (cart) {
        state.cart = cart;
        updateCartBadges(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  function refresh(options) {
    options = options || {};

    if (!state.isOpen) {
      return refreshBadgeOnly();
    }

    // Coalesce — never queue a second full network+render while one is running.
    if (state.renderPromise) {
      return state.renderPromise;
    }

    var tokenAtStart = state.renderToken;

    state.renderPromise = fetchCart()
      .then(function (cart) {
        if (!state.isOpen || tokenAtStart !== state.renderToken) {
          state.cart = cart;
          updateCartBadges(cart.item_count);
          return cart;
        }

        // Default light refresh — cart:refresh must not re-hit recommendations.
        if (options.full) {
          return renderCart(cart);
        }
        return renderCart(cart, { light: true });
      })
      .catch(function () {})
      .finally(function () {
        state.renderPromise = null;
      });

    return state.renderPromise;
  }

  function onCartOpenClick(event) {
    if (!event.target.closest('[data-cart-drawer-open]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // Already open: do nothing. A double-tap on the cart icon (common when the
    // open animation lags on mobile) must never close the drawer — the icon and
    // the drawer's close button occupy the same spot, so a toggle here made the
    // drawer appear to "force close on itself".
    if (state.isOpen) return;

    open();
  }

  function onDocumentClick(event) {
    if (event.target.closest('[data-gift-bag-zoom-close]') || event.target.closest('[data-gift-bag-zoom-overlay]')) {
      event.preventDefault();
      closeGiftBagZoom();
      return;
    }

    var zoomBtn = event.target.closest('[data-gift-bag-zoom]');
    if (zoomBtn) {
      event.preventDefault();
      event.stopPropagation();
      var zoomImg = zoomBtn.querySelector('img');
      openGiftBagZoom(
        zoomBtn.getAttribute('data-zoom-src'),
        zoomBtn.getAttribute('data-zoom-alt') || (zoomImg && zoomImg.getAttribute('alt')) || ''
      );
      return;
    }

    if (event.target.closest('[data-cart-drawer-shipping-policy-close]')) {
      event.preventDefault();
      closeShippingPolicy();
      return;
    }

    var shippingPolicyTrigger = event.target.closest('[data-cart-drawer-shipping-policy]');
    if (shippingPolicyTrigger) {
      event.preventDefault();
      openShippingPolicy();
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      // Grace period: ghost/double taps right after opening land on the close
      // button or overlay (drawer is still sliding in) — ignore them.
      if (Date.now() - state.openedAt < 350) return;
      close();
      return;
    }

    var removeBtn = event.target.closest('[data-cart-drawer-remove]');
    if (removeBtn) {
      event.preventDefault();
      event.stopPropagation();
      if (state.lineUpdateBusy) return;

      var itemEl = removeBtn.closest('[data-cart-drawer-item]');
      if (!itemEl || !els.items || !els.items.contains(itemEl)) return;

      var itemKey = itemEl.getAttribute('data-key');
      var line = parseInt(itemEl.getAttribute('data-line'), 10);
      if (!itemKey && !line) return;

      if (itemEl.hasAttribute('data-gift-bag-line')) {
        runLineUpdate(setGiftBagQuantity(0));
        return;
      }

      // Optimistic: pull the row out of the DOM immediately (no full list rebuild).
      itemEl.classList.add('is-removing');
      if (itemEl.parentNode) {
        itemEl.parentNode.removeChild(itemEl);
      }

      // Re-index remaining rows so later qty edits stay correct.
      if (els.items) {
        Array.prototype.forEach.call(
          els.items.querySelectorAll('[data-cart-drawer-item]'),
          function (row, index) {
            row.setAttribute('data-line', String(index + 1));
          }
        );
      }

      var remaining = els.items
        ? els.items.querySelectorAll('[data-cart-drawer-item]').length
        : 0;
      if (remaining === 0) {
        els.items.innerHTML = '';
        els.items.classList.add('is-hidden');
        if (els.empty) els.empty.classList.remove('is-hidden');
        if (els.footer) els.footer.classList.add('is-hidden');
      }

      var removePromise = itemKey
        ? changeLineByKey(itemKey, 0)
        : changeLine(line, 0);

      // Sync totals/badge only — item DOM already updated optimistically.
      runLineUpdate(removePromise, { summaryOnly: true });
      return;
    }

    var qtyBtn = event.target.closest('[data-qty-change]');
    if (qtyBtn) {
      event.preventDefault();
      event.stopPropagation();
      if (state.lineUpdateBusy) return;
      var row = qtyBtn.closest('[data-cart-drawer-item]');
      if (!row) return;
      var rowKey = row.getAttribute('data-key');
      var lineId = parseInt(row.getAttribute('data-line'), 10);
      if (!rowKey && !lineId) return;
      var input = row.querySelector('.yt-cart-drawer__qty-input');
      if (!input) return;
      var delta = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      if (isNaN(delta)) return;
      var nextQty = Math.max(0, parseInt(input.value, 10) + delta);
      if (isNaN(nextQty)) nextQty = 0;

      if (nextQty === 0) {
        // Treat qty→0 like remove (same optimistic path).
        removeBtn = row.querySelector('[data-cart-drawer-remove]');
        if (removeBtn) {
          removeBtn.click();
          return;
        }
      }

      input.value = String(nextQty);
      var qtyPromise = rowKey
        ? changeLineByKey(rowKey, nextQty)
        : changeLine(lineId, nextQty);
      runLineUpdate(qtyPromise);
      return;
    }

    var discountRemoveBtn = event.target.closest('[data-cart-drawer-discount-remove]');
    if (discountRemoveBtn) {
      event.preventDefault();
      var discountCode = discountRemoveBtn.getAttribute('data-discount-code');
      if (!discountCode) return;

      discountRemoveBtn.disabled = true;
      clearDiscountMessages();

      removeDiscountCode(discountCode)
        .then(function (cart) {
          if (els.discountInput) els.discountInput.value = '';
          return renderCart(cart);
        })
        .catch(function () {
          discountRemoveBtn.disabled = false;
        });
      return;
    }

    var upsellAdd = event.target.closest('[data-upsell-add]');
    if (upsellAdd) {
      var card = upsellAdd.closest('[data-upsell-card]');
      if (!card) return;
      var variantId = parseInt(card.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      upsellAdd.disabled = true;
      addVariant(variantId, 1)
        .then(function (item) {
          state.lastAddedProductId = item.product_id;
          return refresh({ full: true });
        })
        .catch(function () {})
        .finally(function () {
          upsellAdd.disabled = false;
        });
    }
  }

  var shippingPolicyDialog = document.getElementById('yt-cart-shipping-policy');

  function openShippingPolicy() {
    if (!shippingPolicyDialog) return;
    shippingPolicyDialog.setAttribute('aria-hidden', 'false');
    document.body.classList.add('yt-cart-policy-dialog-open');
  }

  function closeShippingPolicy() {
    if (!shippingPolicyDialog) return;
    shippingPolicyDialog.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('yt-cart-policy-dialog-open');
  }

  function isShippingPolicyOpen() {
    return shippingPolicyDialog && shippingPolicyDialog.getAttribute('aria-hidden') === 'false';
  }

  function isGiftBagZoomOpen() {
    return !!(els.giftZoom && els.giftZoom.getAttribute('aria-hidden') === 'false');
  }

  function openGiftBagZoom(src, alt) {
    if (!els.giftZoom || !els.giftZoomImage || !src) return;
    els.giftZoomImage.src = src;
    els.giftZoomImage.alt = alt || '';
    els.giftZoom.setAttribute('aria-hidden', 'false');
  }

  function closeGiftBagZoom() {
    if (!els.giftZoom) return;
    els.giftZoom.setAttribute('aria-hidden', 'true');
    if (els.giftZoomImage) {
      els.giftZoomImage.removeAttribute('src');
      els.giftZoomImage.alt = '';
    }
  }

  function onKeydown(event) {
    if (event.key !== 'Escape') return;
    if (isGiftBagZoomOpen()) {
      closeGiftBagZoom();
      return;
    }
    if (isShippingPolicyOpen()) {
      closeShippingPolicy();
      return;
    }
    if (state.isOpen) {
      close();
    }
  }

  document.addEventListener('click', onCartOpenClick, true);
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onKeydown);

  if (els.giftNoteToggle) {
    els.giftNoteToggle.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = els.giftNoteToggle.getAttribute('aria-expanded') === 'true';
      state.giftNoteUserClosed = isOpen;
      setGiftNoteOpen(!isOpen, !isOpen);
    });
  }

  if (els.discountToggle) {
    els.discountToggle.addEventListener('click', function () {
      var isOpen = els.discountToggle.getAttribute('aria-expanded') === 'true';
      setDiscountOpen(!isOpen, !isOpen);
    });
  }

  if (els.giftBag) {
    els.giftBag.addEventListener('change', function () {
      if (state.giftBagBusy || !giftBagEnabled()) return;
      var wantBag = els.giftBag.checked;
      state.giftBagBusy = true;

      var action = fetchCart({ force: true }).then(function (cart) {
        var qty = giftBagQuantity(cart);
        if (wantBag) {
          return qty > 0 ? cart : applyGiftBagQuantity(cart, 1);
        }
        return qty > 0 ? applyGiftBagQuantity(cart, 0) : cart;
      });

      runLineUpdate(action).finally(function () {
        state.giftBagBusy = false;
        if (els.giftBag) {
          els.giftBag.checked = giftBagQuantity(state.cart || { items: [] }) > 0;
        }
      });
    });
  }

  if (els.giftNote) {
    var giftNoteTimer;
    els.giftNote.addEventListener('input', function () {
      updateGiftNoteCount();
      clearTimeout(giftNoteTimer);
      giftNoteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Gift note': els.giftNote.value.trim() } })
        }).then(function (res) {
          return res.json();
        }).then(function (cart) {
          state.cart = cart;
        }).catch(function () {});
      }, 400);
    });
  }

  if (els.note) {
    var noteTimer;
    els.note.addEventListener('change', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: els.note.value })
        });
      }, 400);
    });
  }

  var checkoutBtn = drawer.querySelector('[data-cart-drawer-checkout]');
  if (checkoutBtn && els.form && config.displayTos) {
    checkoutBtn.addEventListener('click', function (event) {
      var tos = els.form.querySelector('.tos_agree');
      if (tos && !tos.checked) {
        event.preventDefault();
      }
    });
  }

  if (els.form) {
    els.form.addEventListener('submit', function (event) {
      if (!state.lineUpdateBusy && !state.giftBagBusy) return;
      event.preventDefault();
      var form = els.form;
      var started = Date.now();
      function waitAndSubmit() {
        if ((!state.lineUpdateBusy && !state.giftBagBusy) || Date.now() - started > 4000) {
          form.submit();
          return;
        }
        setTimeout(waitAndSubmit, 50);
      }
      waitAndSubmit();
    });
  }

  function submitDiscountCode() {
    if (!els.discountInput || !els.discountApply) return;

    var code = els.discountInput.value.trim();
    clearDiscountMessages();

    if (!code) {
      showDiscountMessage('error', config.discountErrorLabel || 'Enter a valid discount code');
      return;
    }

    els.discountApply.disabled = true;

    applyDiscountCode(code)
      .then(function (cart) {
        if (discountIsApplied(cart, code)) {
          showDiscountMessage('success', config.discountSuccessLabel || 'Discount applied');
          return renderCart(cart);
        }

        setDiscountOpen(true);
        showDiscountMessage('error', config.discountErrorLabel || 'Enter a valid discount code');
          return renderCart(cart);
      })
      .catch(function () {
        showDiscountMessage('error', config.discountErrorLabel || 'Enter a valid discount code');
      })
      .then(function () {
        els.discountApply.disabled = false;
      });
  }

  if (els.discountApply) {
    els.discountApply.addEventListener('click', submitDiscountCode);
  }

  if (els.discountInput) {
    els.discountInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        submitDiscountCode();
      }
    });

    els.discountInput.addEventListener('input', clearDiscountMessages);
  }

  function setLastAddedProductId(productId) {
    state.lastAddedProductId = productId;
  }

  window.YTCartDrawer = {
    open: open,
    close: close,
    refresh: refresh,
    setLastAddedProductId: setLastAddedProductId
  };

  document.addEventListener('cart:refresh', refresh);
})();
